export default __webpack_public_path__ + "5505dd2b4a636fc3130e28ca6e7b1564.png";